import AgentLicenseService from '@services/agentLicense.service';
import {MO, PA, TX} from '@sellers-shield-home-protection/ss-core-js/src/AppResources/LuStateAppResource';

export const VALID_LICENSE = Object.freeze('VALID_LICENSE');

export const isMagicLicense = (licenseNumber) => {
    if (licenseNumber.startsWith('TEST!SS') || licenseNumber.toLocaleUpperCase().startsWith('TEST')) {
        return true;
    } else {
        return false;
    }
 }

export const verifyIsUniqueLicense = async (stateId, licenseNumber) => {
    try {
        let ul = await AgentLicenseService.isUnique({
            stateId: stateId,
            number: licenseNumber,
            type: (stateId === MO || stateId === PA) ? 'nrds' : 'license',
        });
        return ul.data;
    } catch (e) {
        return 'License number is already used by another account!';
    }
 }

export const verifyIsLicenseValidFromExternalAuthorities = async (stateId, licenseNumber, lastName) => { 
    try {
        let isValidLicense = await AgentLicenseService.checkValidityFromExternalAuthorities({
            stateId: stateId,
            nrdsId: licenseNumber,
            lastName: lastName,
        });
        if(isValidLicense.status == 200){
            console.log('verifyIsLicenseValid', isValidLicense.data);
            if(isValidLicense?.data?.result?.MEMBER) {
                return VALID_LICENSE;
            }
            else {
                return 'License number is not valid!';
            }
        }
        else {
            return 'License number is not valid!';
        }                                
    } catch (error) {
        return 'License number is not valid!';
    }
}

